import { getAppInstance, getSessionBrands } from '/@/store/session/selectors';

export const getBagQualityEnabled = (state) => getAppInstance(state).enableBagQuality;

export const getActiveBrands = (state, type) => getSessionBrands(state)[type];

export const getHistoricalConsultations = (state) => state.bagQuality.historicalConsultations;

export const getBatchData = (state) => state.bagQuality.batchData;

export const getQrCornSeedQualityEnabled = (state) => getAppInstance(state).enableQrCornSeedQuality;
